import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ProductsIcon } from 'assets/icon-products.svg';
import MenuMinihub from './menu-minihub/menu-minihub';

const TobbarProductUser = ({ iconColor }) => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleClick = () => {
    setOpenDialog(!openDialog);
  };

  return (
    <div className="mt-3 tobbar-product-user">
      <ProductsIcon
        className="topbar__help-icon"
        fill={iconColor}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      />
      {openDialog && <MenuMinihub openDialog={openDialog} setOpenDialog={setOpenDialog} />}
    </div>
  );
};

TobbarProductUser.propTypes = {
  iconColor: PropTypes.string.isRequired,
};

export default TobbarProductUser;
